import { render, staticRenderFns } from "./FormContinueMessage.vue?vue&type=template&id=778066c2&scoped=true&"
import script from "./FormContinueMessage.vue?vue&type=script&lang=js&"
export * from "./FormContinueMessage.vue?vue&type=script&lang=js&"
import style0 from "./FormContinueMessage.vue?vue&type=style&index=0&id=778066c2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778066c2",
  null
  
)

export default component.exports